import React, { useEffect, useState } from 'react';

import { capacitorService } from '../application/CapacitorService';
import { storageService } from '../application/StorageService';
import { Modal } from './Modal';

const APP_UPDATE_DISMISSED = `APP_UPDATE_DISMISSED`;

function compareAppleVersions(version1: string, version2: string) {
  const v1 = version1.split(`.`).map(Number);
  const v2 = version2.split(`.`).map(Number);

  for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
    const part1 = v1[i] || 0; // default to 0 if undefined
    const part2 = v2[i] || 0; // default to 0 if undefined

    if (part1 > part2) {
      return 1; // version1 is greater
    } else if (part1 < part2) {
      return -1; // version2 is greater
    }
  }
  return 0; // versions are equal
}

export const UpdateAppModal: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const fetchShowModal = async () => {
    try {
      // TODO REMOVE THIS WHEN WE KNOW IT WORKS
      const result = await storageService.getItem({ key: APP_UPDATE_DISMISSED });
      const hasUpdate = capacitorService.hasDifferentVersion();
      const storeVersion = capacitorService.getStoreVersion();
      if (!storeVersion) return;
      if (capacitorService.isIOS() && compareAppleVersions(storeVersion, result ?? `0.0.0`) > 0 && hasUpdate) {
        // If the store version is greater than the dismissed version
        // setShowModal(true); // Show the modal if not dismissed or dismissed more than 1 day ago
      }
      if (capacitorService.isAndroid() && (!result || Number(result) < Number(storeVersion)) && hasUpdate) {
        // If there was dismissed and there is an update
        setShowModal(true); // Show the modal if not dismissed or dismissed more than 1 day ago
      }
    } catch (error) {
      console.error(`Error fetching modal update:`, error);
    }
  };

  useEffect(() => {
    fetchShowModal();
  });

  const handleOpenStore = (): void => {
    capacitorService.openAppStore();
  };

  //THIS IS AN ASYNC FUNCTION
  const handleCloseModal = async (): Promise<void> => {
    setShowModal(false);
    const storeVersion = capacitorService.getStoreVersion();
    if (!storeVersion) return;
    await storageService.setItem({ key: APP_UPDATE_DISMISSED, item: storeVersion });
  };

  return (
    <>
      {showModal && (
        <Modal
          open
          title={{
            intlId: `drivers.app_update.modal.title`,
          }}
          subtitle={{
            intlId: `drivers.app_update.modal.subtitle`,
          }}
          // isLoading,
          buttons={[
            {
              intlId: `drivers.app_update.modal.dismiss`,
              onClick: () => handleCloseModal(),
              variant: `text`,
              style: {
                border: `none`,
              },
            },
            {
              intlId: `drivers.app_update.modal.update`,
              onClick: () => handleOpenStore(),
            },
          ]}
        />
      )}
    </>
  );
};
